<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Số lượng
        </label>
        <b-input v-model="entry.quantity" type="number" placeholder="Nhập số lượng..." />
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            quantity: "",
        },
    }),
    watch: {
        "entry.quantity": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    quantity: this.entry.quantity,
                });
            },
            deep: true,
        },
        "value.quantity": {
            handler: function () {
                this.entry.quantity = this.value.quantity;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>